import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      login: "Login",
      developed_by: "developed by",
      support_from: "support from",
      home: "Home",
      banner_title: "VIRTUAL VIOLATIONS DETECTORS",
      banner_desc:
        "MCMDP is an automated solution that uses artificial intelligence and supervised machine learning to detect advertising violations on digital platforms.",
      explore: "Explore",
      title_home_desc: "MCMDP ON THE CODE",
      content_home_desc:
        "Inappropriate marketing of breastmilk substitutes, bottles and teats, and foods for infants and young children undermines breastfeeding and infant young child nutrition, and violates the International Code of Marketing of Breast-milk Substitutes (the Code).\nThe  marketing  is  especially  rampant  on  digital platforms, and MCMDP is an effective virtual assistant to help detect Code violation.",
      main_function: "MAIN FUCNTIONS",
      function_desc: "MCMDP has three main functions:",
      function1: "Auto-detecting Code violations 24/7",
      function2: "Labelling Code violations upon requests",
      function3: "Tracing violations from detection to penalty",
      auto_detect: "Auto-detect violations",
      resource_center: "Resource Center",
      trace_violation: "Trace violation",
      violation_list: "Violation list",
      nonviolation_list: "Non-violation list",
      account_management: "Account Management",
      track_form: "Submit suspected violations",
      auto_detect_desc:
        "Explore the list of advertisements detected by Artificial Intelligence (and supervised by our experts) regarding digital marketing of products covered by the International Code of Marketing of Breast-milk Substitutes (including formulas and infant milks, bottles, nipples, and commercial complementary foods).",
      search: "Search",
      company_search: "Parent Company",
      brand_search: "Brand",
      select_date: "Please select date",
      apply_btn: "Apply",
      showing: "Showing",
      export_excel: "Export Excel",
      number: "No",
      company: "Company",
      parent_company: "Parent Company",
      brand: "Brand",
      caption: "Caption",
      image: "Image",
      public_date: "Publish date",
      crawl_date: "Crawl date",
      link: "Link",
      international_law: "MCMDP - International Code",
      violation_status: "Status",
      violation_code: "Code article",
      law_article: "Law article",
      violation_type: "Violation type",
      mongolia_law: "MCMDP - Mongolian Law",
      REVIEWED: "Reviewed",
      PENDING: "Pending",
      PUBLIC: "Public",
      NO_PUBLIC: "No Public",
      VIOLATION: "Violation",
      NON_VIOLATION: "Non Violation",
      violation_list_desc:
        "In this section, you have shared and reported violations list specifically from digital environments which reviewed by organization. These violations are then analyzed by our AI tool and reviewed, which processes the data to detect patterns, categorize incidents, and generate insights for further review and action.",
      international_btn: "International Code",
      mongolia_btn: "Mongolia Law",
      heading1: "Report Violations International Code of",
      heading2: "Marketing of Breast-milk Substitutes and",
      heading3: "relevant WHA resolutions",
      name: "Name",
      email: "Email",
      affiliations: "Affiliations",
      city: "City",
      desc: "Short description of the violation",
      location: "Where did violation take place? (place, city and country)",
      brand_name: "Brand name",
      company_name: "Company name",
      product_desc: "Specify",
      type_violations: "Type of violations",
      violation_desc: "Specify",
      attach_photo: "Please attach photo, if possible",
      drop_file: "Drag and drop files here",
      footer_text:
        "This tool has been produced with the assistance of the European Union. The content and features of this tool are the sole responsibility of the Department of Hygiene and Health Promotion, Ministry of Health, Lao PDR and UNICEF and in no way be taken to reflect the views of the European Union.",
      content: "Content",
      checklist_title:
        "For complementary foods / foods for infants and young children, check if:",
      item1:
        "The product is marketed or represented as suitable for below 6 months.",
      item2:
        "The product includes a statement on the importance of continued breastfeeding for up to two years or beyond and the importance of not introducing complementary feeding before 6 months of age.",
      item3: "There is any text or image that undermines breastfeeding.",
      item4:
        "The product is promoted in healthcare facilities, regardless of age indication.",
      item5:
        "The labelling and packaging look similar to breastmilk substitute products (cross-promotion).",
      violation_note:
        "(Any of the above constitutes a violation of the 2016 WHO Guidance.)",
      browser_file: "Browser file",
      //
      "Advertisement: mass media, print, digital platforms/social media, billboards, or other channels":
        "Advertisement: mass media, print, digital platforms/social media, billboards, or other channels",
      "Company contact with pregnant women and mothers":
        "Company contact with pregnant women and mothers",
      "Free samples": "Free samples",
      "Donation of BMS or complementary food products to health facilities or in Emergencies":
        "Donation of BMS or complementary food products to health facilities or in Emergencies",
      "Gift to mothers": "Gift to mothers",
      "Inadequate labeling": "Inadequate labeling",
      "Promotion in shops": "Promotion in shops",
      Sponsorship: "Sponsorship",
      "Other (specify)": "Other (specify)",
      phone_number: "Phone number",
      authority: "Authority",
      edit: "Edit",
      delete: "Delete",
      add_account: "Add account",
      information_personal: "Personal information",
      log_out: "Log out",
      contact: "Contact",
      report_title: "SUBMIT SUPECTED VIOLATIONS",
      report_title1: "Submit supected violations",
      submit_content:
        "Report Violations International Code of Marketing of Breast-milk Substitutes and relevant WHA resolutions",
      submit_btn: "Submit",
      report_dsc:
        "In this section, you can share and report violations observed in environments such as healthcare institutions, scientific-professional events, retail points of sale, traditional media, or public spaces.",
      description: "Description",
      place_observation: "Where suspected violation was found",
      contact_us: "Contact us",
      apply: "Apply",
      international_code: "International code",
      detected: "Detected",
      no_detected: "No Detected",
      select: "Select",
      cancel: "Cancel",
      save_changes: "Save",
      back: "Back",
      filter: "Filter",
      copied: "Copied",
      not_copy: "Link does not work",
      type_of_violation: "Type of Violation",
      detail: "DETAILS",
      copy_link: "Copy link",
      confirm_changes: "Confirm changes",
      revision: "Revision",
      export: "Export",
      rememberPass: "Remember Password",
      forgetPass: "Forget Password",
      achieved: "Archived",
      password: "Password",
      days: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      submit_violation: "View reported violations",
      report: "Report",
      form_title:
        "Report Violations International Code of Marketing of Breast-milk Substitutes and relevant WHA resolutions",
      date_observation: "Date of observation",
      city_province: "City/Province",
      province: "Province",
      specify: "Specify",
      observationObject: "Activity observed",
      brand_company: "Brand/Company",
      type_of_product: "Type of products",
      upload_box: "Box to upload image",
      personal_information:
        "Personal information (*We collect personal information to facilitate further communications and clarifications of reported suspected violations when necessary. All personal information will be kept as confidential.)",
      affilation: "Affiliation",
      additional_information: "Additional information",
      select_violation_type: "Select violation type",
      full_name: "Full name",
      //
      "Health facilities": "Health facilities",
      "Retail locations":
        "Retail locations: Stores, pharmacies, or supermarkets",
      "Mass media": "Mass media (TV, radio, magazines, newspapers, etc.)",
      "Digital platforms": "Digital platforms (social media, websites)",
      "Public spaces": "Public spaces",
      "Scientific events": "Scientific/professional events",
      "Public events": "Public or commercial events",
      Other: "Other (specify)",
      //
      "Infant formula (including special formula) (or Stage 1)":
        "Infant formula (including special formula) (or Stage 1)",
      "Follow-up formula (or Stage 2)": "Follow-up formula (or Stage 2)",
      "Growing-up milk (or Stage 3)": "Growing-up milk (or Stage 3)",
      growing_up_milk: "Growing-up milk (or Stage 3)",
      "Feeding bottle and teat": "Feeding bottle and teat",
      "Complementary foods or beverages / foods for infants and young children (E.g. cereals, fruit/vegetables/meat puree, juice, tea, and mineral water)":
        "Complementary foods or beverages / foods for infants and young children (E.g. cereals, fruit/vegetables/meat puree, juice, tea, and mineral water)",
      //
      "France Lait": "France Lait",
      Nutricia: "Nutricia",
      Lactogen: "Lactogen",
      Lactagrow: "Lactagrow",
      "S-26": "S-26",
      Dugro: "Dugro",
      "Dumex Gold Plus": "Dumex Gold Plus",
      DG: "DG",
      Phyciolac: "Phyciolac",
      Cerelac: "Cerelac",
      "Happy Bites": "Happy Bites",
      "Xong Dur Baby": "Xong Dur Baby",
      "Dozo Grain": "Dozo Grain",
      Natur: "Natur",
      Attoon: "Attoon",
      Pigeon: "Pigeon",
      Babito: "Babito",
      ok: "OK",
      success: "Success",
      success_report: "Form submitted successfully!",
      health_facilities: "Health facilities",
      retail_locations: "Retail locations: Stores, pharmacies, or supermarkets",
      mass_media: "Mass media (TV, radio, magazines, newspapers, etc.)",
      digital_platforms: "Digital platforms (social media, websites)",
      public_spaces: "Public spaces",
      scientific_events: "Scientific/professional events",
      public_events: "Public or commercial events",
      advertisement:
        "Advertisement: mass media, print, digital platforms/social media, billboards, or other channels",
      company_contact: "Company contact with pregnant women and mothers",
      free_samples: "Free samples",
      donation:
        "Donation of BMS or complementary food products to health facilities or in Emergencies",
      gift_to_mothers: "Gift to mothers",
      inadequate_labeling: "Inadequate labeling",
      promotion_in_shops: "Promotion in shops",
      sponsorship: "Sponsorship",
      other: "Other (specify)",

      infant_formula: "Infant formula (including special formula) (or Stage 1)",
      follow_up_formula: "Follow-up formula (or Stage 2)",
      feeding_bottle_teat: "Feeding bottle and teat",
      complementary_foods_beverages:
        "Complementary food or beverage / food for infants and young children (E.g. cereals, fruit/vegetables/meat puree, juice, tea, and mineral water specifically marketed for children under 36 months)",
      "Complementary milk formula for pregnant and lactating women":
        "Complementary milk formula for pregnant and lactating women",
      delete_user: "Delete User",
      delete_content: "Are you sure you want to delete this user?",
      confirmPass: "Confirm Password",
      add_name_placeholder: "Enter your name",
      add_email_placeholder: "Enter your email",
      add_phone_number_placeholder: "Enter your phone number",
      add_password_placeholder: "Enter your password",
      add_re_password_placeholder: "Re-enter your confirmation password",
      full_name_required: "Please enter your full name",
      email_required: "Email is required",
      email_invalid: "Email must be a valid address",
      phone_numbers_only: "Please enter numbers only",
      phone_required: "Please enter your phone number",
      password_min_length: "Password must be at least 6 characters long",
      password_required: "Please enter your password",
      confirm_password_required: "Please confirm your password",
      passwords_must_match: "Passwords must match",
      role_required: "Please select an option",
      role_invalid: "Invalid option",
      password_invalid: "Password is required",
      recover_password: "Recover password",
      back_to_login: "Back to login",
      information_details: "Information details",
      add_current_password_placeholder: "Current password",
      verification_of_infringements: "VERIFICATION OF INFRINGEMENTS",

      activities_observe: "Activities observe",
      "Code 5.1 - Advertisements / promotion":
        "Code 5.1 - Advertisements / promotion",
      "Code 5.2 - Samples": "Code 5.2 - Samples",
      "Code 5.3 - Discounts / coupons": "Code 5.3 - Discounts / coupons",
      "Code 5.4 - Gifts": "Code 5.4 - Gifts",
      "Code 5.5 - Contact with mothers": "Code 5.5 - Contact with mothers",
      "WHA 58.32 - Nutrition and health claims (BMS, promotion to public)":
        "WHA 58.32 - Nutrition and health claims (BMS, promotion to public)",
      "WHA 63.23 - Nutrition and health claims (CF, promotion to public)":
        "WHA 63.23 - Nutrition and health claims (CF, promotion to public)",
      "Code 9.2 - Inadequate labeling / missing information":
        "Code 9.2 - Inadequate labeling / missing information",
      "WHA 58.32 + WHA 61.20 - Missing contamination warning and preparation (labeling)":
        "WHA 58.32 + WHA 61.20 - Missing contamination warning and preparation (labeling)",
      "Code 9.1 + Code 9.2 - Idealizing product or undermining breastfeeding (labeling)":
        "Code 9.1 + Code 9.2 - Idealizing product or undermining breastfeeding (labeling)",
      "WHA 58.32 - Nutrition and health claims (BMS, labeling)":
        "WHA 58.32 - Nutrition and health claims (BMS, labeling)",
      "WHA 63.23 - Nutrition and health claims (CF, labeling)":
        "WHA 63.23 - Nutrition and health claims (CF, labeling)",
      "Code 4.3 - IEM by company": "Code 4.3 - IEM by company",
      "Code 4.2 - IEM / Inadequate information":
        "Code 4.2 - IEM / Inadequate information",
      "Code 4.2 - IEM / inadequate information on use of infant formula":
        "Code 4.2 - IEM / inadequate information on use of infant formula",
      "WHA 58.32 - IEM / Missing contamination warning and preparation":
        "WHA 58.32 - IEM / Missing contamination warning and preparation",
      "Code 4.2 - IEM / Idealizing product or undermining breastfeeding":
        "Code 4.2 - IEM / Idealizing product or undermining breastfeeding",
      "Code 4.3 - IEM / Reference to brands":
        "Code 4.3 - IEM / Reference to brands",
      "WHA 58.32 - IEM / Nutrition and health claims (BMS)":
        "WHA 58.32 - IEM / Nutrition and health claims (BMS)",
      "WHA 63.23 - IEM / Nutrition and health claims (CF)":
        "WHA 63.23 - IEM / Nutrition and health claims (CF)",
      "Code 7.2 - Info for health workers / idealizing":
        "Code 7.2 - Info for health workers / idealizing",
      "Code 7.2 - Info for health workers / inadequate info":
        "Code 7.2 - Info for health workers / inadequate info",
      "WHA 58.32 - Info for health workers / Nutrition and health claims (BMS)":
        "WHA 58.32 - Info for health workers / Nutrition and health claims (BMS)",
      "WHA 63.23 - Info for health workers / Nutrition and health claims (CF)":
        "WHA 63.23 - Info for health workers / Nutrition and health claims (CF)",
      "Code 7.5; WHA49.15; WHA58.32 - Sponsorships / COI":
        "Code 7.5; WHA49.15; WHA58.32 - Sponsorships / COI",
      "2016 WHO Guidance Rec 4": "2016 WHO Guidance Rec 4",
      "2016 WHO Guidance Rec 4 / Inadequate info":
        "2016 WHO Guidance Rec 4 / Inadequate info",
      "2016 WHO Guidance Rec 5 / BMS-CF Cross promotion labeling and packaging":
        "2016 WHO Guidance Rec 5 / BMS-CF Cross promotion labeling and packaging",
      "2016 WHO Guidance Rec 5 / BMS-CF Cross promotion (contact with mothers)":
        "2016 WHO Guidance Rec 5 / BMS-CF Cross promotion (contact with mothers)",
      "2016 WHO Guidance Rec 6 / Samples": "2016 WHO Guidance Rec 6 / Samples",
      "2016 WHO Guidance Rec 6 / COI": "2016 WHO Guidance Rec 6 / COI",

      "Promotion to the public": "Promotion to the public",
      "Labeling - required text/message (including packaging and messaging)":
        "Labeling - required text/message (including packaging and messaging)",
      "Prohibited text/message": "Prohibited text/message",
      "Information and Education": "Information and Education",
      "Information for Health Workers": "Information for Health Workers",
      "Sponsorships / Conflicts of Interest":
        "Sponsorships / Conflicts of Interest",
      "2016 WHO Guidance (*CF)": "2016 WHO Guidance (*CF)",
      "Complementary foods": "Complementary foods",

      "10.1 - Advertisements / promotion": "10.1 - Advertisements / promotion",
      "10.3 - Samples": "10.3 - Samples",
      "10.2.1 - Discounts/coupons": "10.2.1 - Discounts/coupons",
      "10.5 - Inappropriate use of brand name or logo":
        "10.5 - Inappropriate use of brand name or logo",
      "10.3-Distribute free (to promote BMS)":
        "10.3-Distribute free (to promote BMS)",
      "6.3.4-Prohibited to place health and nutrition claim":
        "6.3.4-Prohibited to place health and nutrition claim",
      "7.1.2 - Inadequate labeling / missing information":
        "7.1.2 - Inadequate labeling / missing information",
      "7.1.3 - Inadequate labeling / missing information":
        "7.1.3 - Inadequate labeling / missing information",
      "6.1.1 - Inadequate labeling / missing information":
        "6.1.1 - Inadequate labeling / missing information",
      "6.1.2 - Inadequate labeling / missing information":
        "6.1.2 - Inadequate labeling / missing information",
      "7.1.1 - Inadequate labeling / missing information":
        "7.1.1 - Inadequate labeling / missing information",
      "6.3.1; 7.2 - Idealizing product or undermining breastfeeding (labeling)":
        "6.3.1; 7.2 - Idealizing product or undermining breastfeeding (labeling)",
      "6.3.3 - Idealizing product or undermining breastfeeding (labeling)":
        "6.3.3 - Idealizing product or undermining breastfeeding (labeling)",
      "6.3.4 - Nutrition and health claims (BMS, labeling)":
        "6.3.4 - Nutrition and health claims (BMS, labeling)",
      "6.3.4 - Nutrition and health claims (CF, labeling)":
        "6.3.4 - Nutrition and health claims (CF, labeling)",
      "8.1.1 - Inadequate labeling / missing information":
        "8.1.1 - Inadequate labeling / missing information",
      "8.1.2 - Inadequate labeling / missing information":
        "8.1.2 - Inadequate labeling / missing information",
      "8.1.4 - Inadequate labeling / missing information":
        "8.1.4 - Inadequate labeling / missing information",
      "8.3 - Inadequate labeling / missing information":
        "8.3 - Inadequate labeling / missing information",
      "9.1.1 - Inadequate labeling / missing information":
        "9.1.1 - Inadequate labeling / missing information",
      "9.1.2 - Inadequate labeling / missing information":
        "9.1.2 - Inadequate labeling / missing information",
      "9.5 - Appropriate age range": "9.5 - Appropriate age range",
      "9.5 - Inadequate labeling / missing information":
        "9.5 - Inadequate labeling / missing information",
      "9.2 - Idealizing product or undermining breastfeeding (labeling)":
        "9.2 - Idealizing product or undermining breastfeeding (labeling)",
      "9.3 - Endorsement by health professionals":
        "9.3 - Endorsement by health professionals",
      "9.5 - Idealizing product or undermining breastfeeding (labeling)":
        "9.5 - Idealizing product or undermining breastfeeding (labeling)",
      "10.2.2 - IEM by company": "10.2.2 - IEM by company",
      "12.1.3 - IEM / inadequate information on use of infant formula":
        "12.1.3 - IEM / inadequate information on use of infant formula",
      "12.1.2 - IEM / inadequate information on use of infant formula":
        "12.1.2 - IEM / inadequate information on use of infant formula",
      "12.1.1 - IEM / inadequate information on use of infant formula":
        "12.1.1 - IEM / inadequate information on use of infant formula",
      "10.2.2 - IEM / Reference to brands":
        "10.2.2 - IEM / Reference to brands",
      "6.3.4-Health and nutrition claim": "6.3.4-Health and nutrition claim",
      "13.1.2001": "13.1.2001",
      "13.1.1 Method of use": "13.1.1 Method of use",
      "10.2.3; 10.2.5; 10.2.6": "10.2.3; 10.2.5; 10.2.6",
      "8.2 - Prohibited text and images for CF":
        "8.2 - Prohibited text and images for CF",
      "8.1.3 - Prohibited text and images for CF":
        "8.1.3 - Prohibited text and images for CF",
      10.3: "10.3",
      "10.2.7; 10.3": "10.2.7; 10.3",
      "10.2.5 - Sponsorship/COI": "10.2.5 - Sponsorship/COI",
      "10.2.4-place IEC materials": "10.2.4-place IEC materials",
      "10.2.6 - Sponsorship/COI": "10.2.6 - Sponsorship/COI",
      form_success: "Form submitted successfully!",
      address: "Address",
      legal_document: "Legal documents",

      "Complementary food or beverage / food for infants and young children (E.g. cereals, fruit/vegetables/meat puree, juice, tea, and mineral water specifically marketed for children under 36 months)": "Complementary food or beverage / food for infants and young children (E.g. cereals, fruit/vegetables/meat puree, juice, tea, and mineral water specifically marketed for children under 36 months)",

      "arkhangai": "Arkhangai",
      "bayankhongor": "Bayankhongor",
      "bayan_olgii": "Bayan-Ölgii",
      "darkhan_uul": "Darkhan-Uul",
      "dornod": "Dornod",
      "dornogovi": "Dornogovi",
      "dundgobi": "Dundgobi",
      "govi_altai": "Govi-Altai",
      "govisumber": "Govisumber",
      "khentii": "Khentii",
      "khuvsgul": "Khuvsgul",
      "orkhon": "Orkhon",
      "umnugovi": "Umnugovi",
      "uvurrkhangai": "Uvurrkhangai",
      "selenge": "Selenge",
      "tuv": "Tuv",
      "uvs": "Uvs",
      "zavkhan": "Zavkhan",
      "ulaanbaatar": "Ulaanbaatar",

      "tsetserleg": "Tsetserleg",
      "ulgii": "Ulgii",
      "bulgan": "Bulgan",
      "darkhan": "Darkhan",
      "choibalsan": "Choibalsan",
      "sainshand": "Sainshand",
      "mandalgobi": "Mandalgobi",
      "ailtai": "Ailtai",
      "choir": "Choir",
      "chingis": "Chingis",
      "khovd": "Khovd",
      "murun": "Murun",
      "erdenet": "Erdenet",
      "dalanzadgad": "Dalanzadgad",
      "arvaikheer": "Arvaikheer",
      "sukhbaatar": "Sukhbaatar",
      "baruun_urt": "Baruun-Urt",
      "zuunmod": "Zuunmod",
      "ulaangom": "Ulaangom",
      "uliastai": "Uliastai",

      "mamako": "Mamako",
      "nutrilak": "Nutrilak",
      "babybio": "Babybio",
      "humana": "Humana",
      "pigeon": "Pigeon",
      "dr_browns": "Dr.Brown's Mongolia",
      "baboo": "Baboo Mongolia",
      "twistshake": "Twistshake Mongolia",
      "heorshe": "HEORSHE Mongolia",
      "munchkin": "MUNCHKIN Mongolia",
      "wee_baby": "Wee baby",
      "haakaa": "Haakaa Mongolia",
      "nutrilon": "Nutrilon",
      "nan": "NAN",
      "nestogen": "Nestogen",
      "hero_baby": "Hero Baby",

      "nutricia": "Nutricia",
      "nestle": "Nestle",
      "hero": "Hero",

      "To be updated soon": "To be updated soon",
      "Mongolia Code Monitoring Digital Platform (MCMDP)": "Mongolia Code Monitoring Digital Platform (MCMDP)",
      "Name of reviewer": "Name of reviewer",

    },
  },
  mn: {
    translation: {
      law_article: "Хуулийн заалт",
      "Name of reviewer": "байцаагчийн нэр",
      "Mongolia Code Monitoring Digital Platform (MCMDP)": "Нялх, балчир хүүхдийн хүнсний зар сурталчилгааны хяналтын платформ",
      "tsetserleg": "Цэцэрлэг",
      "bayankhongor": "Баянхонгор",
      "ulgii": "Өлгий",
      "bulgan": "Булган",
      "darkhan": "Дархан",
      "choibalsan": "Чойбалсан",
      "sainshand": "Сайншанд",
      "mandalgobi": "Мандалговь",
      "ailtai": "Алтай",
      "choir": "Чойр",
      "chingis": "Чингис",
      "khovd": "Ховд",
      "murun": "Мөрөн",
      "erdenet": "Эрдэнэт",
      "dalanzadgad": "Даланзадгад",
      "arvaikheer": "Арвайхээр",
      "sukhbaatar": "Сүхбаатар",
      "baruun_urt": "Баруун-Урт",
      "zuunmod": "Зуунмод",
      "ulaangom": "Улаангом",
      "uliastai": "Улиастай",

      province: "Аймаг",
      "To be updated soon": "Удахгүй шинэчлэгдэх болно",
      "mamako": "Mamako",
      "nutrilak": "Nutrilak",
      "babybio": "Babybio",
      "humana": "Humana",
      "pigeon": "Pigeon",
      "dr_browns": "Dr.Brown's Mongolia",
      "baboo": "Baboo Mongolia",
      "twistshake": "Twistshake Mongolia",
      "heorshe": "HEORSHE Mongolia",
      "munchkin": "MUNCHKIN Mongolia",
      "wee_baby": "Wee baby",
      "haakaa": "Haakaa Mongolia",
      "nutrilon": "Nutrilon",
      "nan": "NAN",
      "nestogen": "Nestogen",
      "hero_baby": "Hero Baby",

      "nutricia": "Nutricia",
      "nestle": "Nestle",
      "hero": "Hero",

      "arkhangai": "Архангай",
      "bayan_olgii": "Баян-Өлгий",
      "darkhan_uul": "Дархан-Уул",
      "dornod": "Дорнод",
      "dornogovi": "Дорноговь",
      "dundgobi": "Дундговь",
      "govi_altai": "Говь-Алтай",
      "govisumber": "Говьсүмбэр",
      "khentii": "Хэнтий",
      "khuvsgul": "Хөвсгөл",
      "orkhon": "Орхон",
      "umnugovi": "Өмнөговь",
      "uvurrkhangai": "Өвөрхангай",
      "selenge": "Сэлэнгэ",
      "tuv": "Төв",
      "uvs": "Увс",
      "zavkhan": "Завхан",
      "ulaanbaatar": "Улаанбаатар",


      legal_document: "Хууль эрх зүйн баримт бичиг",
      ok: "Тийм",
      address: "Хаяг",
      success: "Амжилт",
      form_success: "Маягтыг амжилттай илгээсэн!",
      "10.1 - Advertisements / promotion": "10.1 - Зар сурталчилгаа",
      "10.3 - Samples": "10.3 - Бүтээгдэхүүний дээж",
      "10.2.1 - Discounts/coupons": "10.2.1 - Хямдрал / Купон",
      "10.5 - Inappropriate use of brand name or logo":
        "10.5 - Брендийн нэр, логог зохисгүй ашиглах",
      "10.3-Distribute free (to promote BMS)":
        "10.3-Бэлэглэх (Зориулалтын бүтээгдэхүүнийг худалдах зорилгоор)",
      "6.3.4-Prohibited to place health and nutrition claim":
        "6.3.4-Шошгод эрүүл мэнд, шим тэжээлийн мэдэгдэл байршуулахыг хориглоно",
      "7.1.2 - Inadequate labeling / missing information":
        "7.1.2 - Хангалтгүй шошгололт / мэдээлэл дутуу",
      "7.1.3 - Inadequate labeling / missing information":
        "7.1.3 - Хангалтгүй шошгололт / мэдээлэл дутуу",
      "6.1.1 - Inadequate labeling / missing information":
        "6.1.1 - Хангалтгүй шошгололт / мэдээлэл дутуу",
      "6.1.2 - Inadequate labeling / missing information":
        "6.1.2 - Хангалтгүй шошгололт / мэдээлэл дутуу",
      "7.1.1 - Inadequate labeling / missing information":
        "7.1.1 - Хангалтгүй шошгололт / мэдээлэл дутуу",
      "6.3.1; 7.2 - Idealizing product or undermining breastfeeding (labeling)":
        "6.3.1; 7.2 - Бүтээгдэхүүний найрлагыг эхийн сүүтэй адилтгасан, эсвэл эхийн сүүгээр хооллолтыг үгүйсгэсэн  (шошго)",
      "6.3.3 - Idealizing product or undermining breastfeeding (labeling)":
        "6.3.3 - Бүтээгдэхүүний найрлагыг эхийн сүүтэй адилтгасан, эсвэл эхийн сүүгээр хооллолтыг үгүйсгэсэн  (шошго)",
      "6.3.4 - Nutrition and health claims (BMS, labeling)":
        "6.3.4 - Nutrition and health claims (BMS, labeling)",
      "6.3.4 - Nutrition and health claims (CF, labeling)":
        "6.3.4 - Nutrition and health claims (CF, labeling)",
      "8.1.1 - Inadequate labeling / missing information":
        "8.1.1 - Хангалтгүй шошгололт / мэдээлэл дутуу",
      "8.1.2 - Inadequate labeling / missing information":
        "8.1.2 - Хангалтгүй шошгололт / мэдээлэл дутуу",
      "8.1.4 - Inadequate labeling / missing information":
        "8.1.4 - Хангалтгүй шошгололт / мэдээлэл дутуу",
      "8.3 - Inadequate labeling / missing information":
        "8.3 - Хангалтгүй шошгололт / мэдээлэл дутуу",
      "9.1.1 - Inadequate labeling / missing information":
        "9.1.1 - Хангалтгүй шошгололт / мэдээлэл дутуу",
      "9.1.2 - Inadequate labeling / missing information":
        "9.1.2 - Хангалтгүй шошгололт / мэдээлэл дутуу",
      "9.5 - Appropriate age range": "9.5 - Appropriate age range",
      "9.5 - Inadequate labeling / missing information":
        "9.5 - Хангалтгүй шошгололт / мэдээлэл дутуу",
      "9.2 - Idealizing product or undermining breastfeeding (labeling)":
        "9.2 - Бүтээгдэхүүний найрлагыг эхийн сүүтэй адилтгасан, эсвэл эхийн сүүгээр хооллолтыг үгүйсгэсэн  (шошго)",
      "9.3 - Endorsement by health professionals":
        "9.3 - Endorsement by health professionals",
      "9.5 - Idealizing product or undermining breastfeeding (labeling)":
        "9.5 - Бүтээгдэхүүний найрлагыг эхийн сүүтэй адилтгасан, эсвэл эхийн сүүгээр хооллолтыг үгүйсгэсэн  (шошго)",
      "10.2.2 - IEM by company": "10.2.2 - IEM by company",
      "12.1.3 - IEM / inadequate information on use of infant formula":
        "12.1.3 - IEM / inadequate information on use of infant formula",
      "12.1.2 - IEM / inadequate information on use of infant formula":
        "12.1.2 - IEM / inadequate information on use of infant formula",
      "12.1.1 - IEM / inadequate information on use of infant formula":
        "12.1.1 - IEM / inadequate information on use of infant formula",
      "10.2.2 - IEM / Reference to brands":
        "10.2.2 - IEM / Reference to brands",
      "6.3.4-Health and nutrition claim": "6.3.4-Health and nutrition claim",
      "13.1.2001": "13.1.2001",
      "13.1.1 Method of use": "13.1.1 Method of use",
      "10.2.3; 10.2.5; 10.2.6": "10.2.3; 10.2.5; 10.2.6",
      "8.2 - Prohibited text and images for CF":
        "8.2 - Prohibited text and images for CF",
      "8.1.3 - Prohibited text and images for CF":
        "8.1.3 - Prohibited text and images for CF",
      10.3: "10.3",
      "10.2.7; 10.3": "10.2.7; 10.3",
      "10.2.5 - Sponsorship/COI": "10.2.5 - Sponsorship/COI",
      "10.2.4-place IEC materials": "10.2.4-place IEC materials",
      "10.2.6 - Sponsorship/COI": "10.2.6 - Sponsorship/COI",

      "Complementary foods": "2016 ДЭМБ-ын удирдамж (*Нэмэгдэл хооллолт)",

      "Promotion to the public": "Нийт сурталчлах",
      "Labeling - required text/message (including packaging and messaging)":
        "Шошгололт - шаардлагатай бичвэр/мэдээлэл (сав, баглаа боодол, мэдээлэл)",
      "Prohibited text/message": "Хориглосон",
      "Information and Education": "Мэдээлэл ба сургалт",
      "Information for Health Workers":
        "Эрүүл мэндийн мэргэжилтэнд зориулсан мэдээлэл",
      "Sponsorships / Conflicts of Interest":
        "Ивээн тэтгэх / Ашиг сонирхолын зөрчил",
      "2016 WHO Guidance (*CF)": "2016 ДЭМБ-ын удирдамж (*Нэмэгдэл хооллолт)",

      "Code 5.1 - Advertisements / promotion":
        "Code 5.1 - Зар сурталчилгаа / урамшуулал",
      "Code 5.2 - Samples": "Code 5.2 - Дээж",
      "Code 5.3 - Discounts / coupons": "Code 5.3 - Хямдрал / Купон",
      "Code 5.4 - Gifts": "Code 5.4 - Бэлэг",
      "Code 5.5 - Contact with mothers": "Code 5.5 - Эхчүүдтэй холбогдох",
      "WHA 58.32 - Nutrition and health claims (BMS, promotion to public)":
        "WHA 58.32 - Эрүүл мэнд, шим тэжээлийн мэдэгдэл (Зориулалтын бүтээгдэхүүн, нийтэд сурталчлах)",
      "WHA 63.23 - Nutrition and health claims (CF, promotion to public)":
        "WHA 63.23 - Эрүүл мэнд, шим тэжээлийн мэдэгдэл (Нэмэгдэл хоол, нийтэд сурталчлах)",
      "Code 9.2 - Inadequate labeling / missing information":
        "Code 9.2 - Хангалтгүй шошгололт / мэдээлэл дутуу",
      "WHA 58.32 + WHA 61.20 - Missing contamination warning and preparation (labeling)":
        "WHA 58.32 + WHA 61.20 - Бохирдлын тухай анхааруулга, зөв бэлтгэх мэдээлэл дутуу (Шошгололт)",
      "Code 9.1 + Code 9.2 - Idealizing product or undermining breastfeeding (labeling)":
        "Code 9.1 + Code 9.2 - Эхийн сүүтэй адилтгасан, эсвэл эхийн сүүгээр хооллолтыг үгүйсгэсэн (шошгололт)",
      "WHA 58.32 - Nutrition and health claims (BMS, labeling)":
        "WHA 58.32 - Эрүүл мэнд, шим тэжээлийн мэдэгдэл (Зориулалтын бүтээгдэхүүн, шошгололт)",
      "WHA 63.23 - Nutrition and health claims (CF, labeling)":
        "WHA 63.23 - Эрүүл мэнд, шим тэжээлийн мэдэгдэл (Нэмэгдэл хоол, шошгололт)",
      "Code 4.3 - IEM by company":
        "Code 4.3 - Компаний мэдээлэл, сурталчилгааны материал",
      "Code 4.2 - IEM / Inadequate information":
        "Code 4.2 - МСМ / хангалтгүй мэдээлэл",
      "Code 4.2 - IEM / inadequate information on use of infant formula":
        "Code 4.2 - МСМ / Нялхсын сүүн тэжээлийн талаар хангалтгүй мэдээлэл",
      "WHA 58.32 - IEM / Missing contamination warning and preparation":
        "WHA 58.32 - МСМ / Бохирдлын талаарх анхааруулга, зөв бэлтгэх мэдээлэл дутуу",
      "Code 4.2 - IEM / Idealizing product or undermining breastfeeding":
        "Code 4.2 - МСМ / IБүтээгдэхүүний найрлагыг эхийн сүүтэй адилтгасан, эсвэл эхийн сүүгээр хооллолтыг үгүйсгэсэн",
      "Code 4.3 - IEM / Reference to brands":
        "Code 4.3 - МСМ / Брендийн лавлагаа",
      "WHA 58.32 - IEM / Nutrition and health claims (BMS)":
        "WHA 58.32 - МСМ / Эрүүл мэнд, шим тэжээлийн мэдэгдэл (Зориулалтын бүтээгдэхүүн)",
      "WHA 63.23 - IEM / Nutrition and health claims (CF)":
        "WHA 63.23 - МСМ / Эрүүл мэнд, шим тэжээлийн мэдэгдэл (Нэмэгдэл хоол)",
      "Code 7.2 - Info for health workers / idealizing":
        "Code 7.2 - Эрүүл мэндийн мэргэжилтэн зориулсан мэдээлэл / адилтгах",
      "Code 7.2 - Info for health workers / inadequate info":
        "Code 7.2 - Эрүүл мэндийн мэргэжилтэн зориулсан мэдээлэл / зохисгүй мэдээлэл",
      "WHA 58.32 - Info for health workers / Nutrition and health claims (BMS)":
        "WHA 58.32 - Эрүүл мэндийн мэргэжилтэн зориулсан мэдээлэл / Эрүүл мэнд, шим тэжээлийн мэдэгдэл (Зориулалтын бүтээгдэхүүн)",
      "WHA 63.23 - Info for health workers / Nutrition and health claims (CF)":
        "WHA 63.23 - Эрүүл мэндийн мэргэжилтэн зориулсан мэдээлэл / Эрүүл мэнд, шим тэжээлийн мэдэгдэл (Нэмэгдэл хоол)",
      "Code 7.5; WHA49.15; WHA58.32 - Sponsorships / COI":
        "Code 7.5; WHA49.15; WHA58.32 - Ивээн тэтгэлэг / Ашиг сонирхолын зөрчил",
      "2016 WHO Guidance Rec 4": "2016 ДЭМБ-ын удирдамж, Зөвлөмж 4",
      "2016 WHO Guidance Rec 4 / Inadequate info":
        "2016 ДЭМБ-ын удирдамж, Зөвлөмж 4 / Хангалтгүй мэдээлэл",
      "2016 WHO Guidance Rec 5 / BMS-CF Cross promotion labeling and packaging":
        "2016 ДЭМБ-ын удирдамж, Зөвлөмж 5 / Зориулалтын бүтээгдэхүүн - Нэмэгдэл хоолны шошго, сав, баглаа боодлыг ашиглан хамтатган сурталчлах",
      "2016 WHO Guidance Rec 5 / BMS-CF Cross promotion (contact with mothers)":
        "2016 ДЭМБ-ын удирдамж, Зөвлөмж 5 / Зориулалтын бүтээгдэхүүн - Нэмэгдэл хоолыг хамтатган сурталчлах (Эхчүүдтэй холбогдох)",
      "2016 WHO Guidance Rec 6 / Samples":
        "2016 ДЭМБ-ын удирдамж, Зөвлөмж 6 / Бүтээгдэхүүний дээж",
      "2016 WHO Guidance Rec 6 / COI":
        "2016 ДЭМБ-ын удирдамж, Зөвлөмж 6 / Ашиг сонирхолын зөрчил",

      delete_user: "Хэрэглэгчийг устгах",
      delete_content: "Та энэ хэрэглэгчийг устгахдаа итгэлтэй байна уу?",
      activities_observe: "Та юу ажигласан (илрүүлсэн) бэ ?",
      add_name_placeholder: "Нэрээ оруулна уу",
      add_email_placeholder: "Имэйлээ оруулна уу",
      add_phone_number_placeholder: "Утасны дугаараа оруулна уу",

      full_name_required: "Өөрийн бүтэн нэрээ оруулна уу",
      email_required: "Имэйл заавал шаардлагатай",
      phone_numbers_only: "Зөвхөн дугаар оруулна уу",
      phone_required: "Утасны дугаараа оруулна уу",
      password_min_length: "Нууц үг дор хаяж 6 тэмдэгт урт байх ёстой",
      password_required: "Нууц үгээ оруулна уу",
      confirm_password_required: "Нууц үгээ баталгаажуулна уу",
      passwords_must_match: "Нууц үгүүд ижил байх ёстой",
      role_required: "Сонголт хийнэ үү",
      role_invalid: "Буруу сонголт",
      password_invalid: "Нууц үг шаардлагатай",
      recover_password: "Нууц үг сэргээх",
      back_to_login: "Буцах",
      information_details: "Мэдээллийн дэлгэрэнгүй",
      add_password_placeholder: "Нууц үгээ оруулна уу",
      add_re_password_placeholder: "Шинэ нууц үгээ дахин оруулна уу",
      add_current_password_placeholder: "Одоогийн нууц үг",
      verification_of_infringements: "Зөрчлийг баталгаажуулалт",

      health_facilities: "Эрүүл мэндийн байгууллага",
      retail_locations: "Эмийн сан, супермаркет, эсвэл дэлгүүр",
      mass_media: "Хэвлэл мэдээлэл",
      digital_platforms: "Дижитал платформууд (нийгмийн сүлжээ, вэбсайтууд)",
      public_spaces: "Нийтийн зам, талбай",
      scientific_events: "Эрдэм шинжилгээ / мэргэжлийн арга хэмжээ ",
      public_events: "Арилжааны арга хэмжээ",
      advertisement:
        "Зар сурталчилгаа: Олон нийтийн мэдээллийн хэрэгсэл, хэвлэл, дижитал платформ/нийгмийн сүлжээ, сурталчилгааны самбар болон бусад суваг",
      company_contact:
        "Компани нь жирэмсэн эмэгтэйчүүд, эхчүүдтэй харилцаа тогтоох",
      free_samples: "Бүтээгдэхүүний дээжийг үнэгүй түгээх",
      donation:
        "Эрүүл мэндийн байгууллагад эхийн сүү орлуулагч бүтээгдэхүүн (зориулалтын бүтээгдэхүүн)-ийг хандивлах",
      gift_to_mothers: "Эхчүүдэд бэлэг өгөх",
      inadequate_labeling: "Зохисгүй шошго / шошгын зөрчил",
      promotion_in_shops:
        "Дэлгүүрт борлуулалтыг нэмэгдүүлэх зорилгоор сурталчилгаа хийх",
      sponsorship: "Ивээн тэтгэх",
      other: "Бусад (тайлбарлах)",
      submit_violation: "Мэдүүлсэн зөрчлийг харах",
      PENDING: "Хүлээгдэж байна",
      REVIEWED: "Шалгасан",
      PUBLIC: "Олон нийт",
      NO_PUBLIC: "Олон нийтэд биш",
      form_title:
        "Нялх, балчир хүүхдийн хүнсний зар сурталчилгааны хууль тогтоомж зөрчсөн талаар мэдүүлэх ",
      observationObject: "Та юу ажигласан (илрүүлсэн) бэ?",
      brand_company: "Бренд / Компани",
      type_of_product: "Бүтээгдэхүүний төрөл",
      upload_box: "Зураг оруулах",
      personal_information: "Хувийн мэдээлэл (Зөрчлийн талаарх гомдлын дагуу хяналт шалгалт хийх шаардлагатай тохиолдолд хувийн мэдээлэл оруулах шаардлагатай. Хувийн мэдээллийн нууцыг чанд хадгална.)",
      affilation: "Компани / Байгууллага",
      additional_information: "Additional information",
      select_violation_type: "Select violation type",
      full_name: "Нэр",
      "Health facilities": "Эрүүл мэндийн байгууллага",
      "Retail locations": "Эмийн сан, супермаркет, эсвэл дэлгүүр",
      "Mass media": "Хэвлэл мэдээлэл",
      "Digital platforms": "Дижитал платформууд (нийгмийн сүлжээ, вэбсайтууд)",
      "Public spaces": "Нийтийн зам, талбай",
      "Scientific events": "Эрдэм шинжилгээ / мэргэжлийн арга хэмжээ",
      "Public events": "Арилжааны арга хэмжээ",
      Other: "Бусад (тайлбарлах)",
      date_observation: "Ажиглалт хийсэн огноо",
      city_province: "Илрүүлсэн зөрчлийн хаяг",
      login: "Нэвтрэх",
      submit_btn: "Илгээх",
      developed_by: "Хөгжүүлсэн",
      support_from: "Дэмжлэг үзүүлсэн",
      home: "Нүүр хуудас",
      banner_title: "Цахим зөрчил илрүүлэгч",
      banner_desc:
        "Нялх, балчир хүүхдийн хүнсний зар сурталчилгааны хяналтын платформ нь хиймэл оюун ухаан, зорилтот мэдээллийн санг ашиглан цахим платформууд дээрх зар сурталчилгааны зөрчлийг илрүүлэх автомат шийдэл юм.",
      explore: "Дэлгэрэнгүй",
      title_home_desc: "Танилцуулга",
      content_home_desc:
        "Нялхсын сүүн тэжээлийн бүтээгдэхүүнүүд, сав, соруул, нялх, балчир хүүхдүүдэд зориулсан хоол хүнсийг зохисгүйгээр сурталчлах нь эхийн сүүгээр хооллох, нялх, балчир хүүхдийн авах шим тэжээлийг бууруулж, олон улсын дүрэм, журам болон Монгол Улсын Нялх, балчир хүүхдийн хүнсний тухай хуулийг зөрчиж байна. \n Энэ чиглэлийн зар сурталчилгаа ялангуяа цахим хуудсуудад ихээхэн тархсан бөгөөд энэхүү платформ нь олон улсын дүрэм, журам болон Монгол Улсын Нялх, балчир хүүхдийн хүнсний тухай хуулийн зөрчлүүдийг илрүүлэх үр дүнтэй цахим хэрэгсэл юм.",
      main_function: "Үндсэн үйл ажиллагаа",
      function_desc: "Энэхүү систем нь дараах 3 үндсэн үүрэгтэй:",
      function: "Кодын зөрчил илрүүлэхийг 24/7 автоматаар",
      function1: "Хуулийн зөрчлийг 24/7 автоматаар илрүүлнэ",
      function2: "Хүсэлтийн дагуу хуулийн зөрчлийг тодорхойлох",
      function3: "Зөрчлийг илрүүлсэн үеэс торгууль ногдуулах хүртэлх үйл явцыг мөшгих",
      auto_detect: "Зөрчлийн автомат  илрүүлэг",
      resource_center: "Хууль тогтоомж",
      trace_violation: "Зөрчлийг мөшгих",
      violation_list: "Зөрчлийн жагсаалт",
      nonviolation_list: "Зөрчилгүй бүтээгдэхүүний жагсаалт",
      account_management: "Бүртгэлийн менежмент",
      track_form: "Болзошгүй зөрчлийг мэдүүлэх",
      auto_detect_desc:
        "Нялх, балчир хүүхдийн хүнсний зар сурталчилгааны хяналтын платформоор илрүүлсэн зар сурталчилгааны жагсаалт (мөн сүү орлуулагч, нярайн сүү, сүүний сав, угж болон худалдаанд байгаа нэмэлт хүнс тэжээл).",
      search: "Хайлт",
      company: "Компани",
      parent_company: "Эзэмшигч компани",
      brand: "Брэнд",
      select_date: "Огноо сонгоно уу",
      apply_btn: "Хайх",
      showing: "Илэрц",
      export_excel: "Excel файлыг татах",
      number: "Дугаар",
      revision: "Засвар",
      caption: "Утга",
      image: "Зураг",
      public_date: "Нийтэлсэн огноо",
      crawl_date: "Хайлтад илэрсэн огноо",
      link: "Холболт",
      international_law: "MCMDP - Олон улсын хууль",
      violation_status: "Төлөв",
      violation_code: "Хуулийн заалт",
      violation_type: "зөрчил",
      mongolia_law: "MCMDP - Монгол Улсын хууль",
      VIOLATION: "Зөрчил",
      NON_VIOLATION: "Зөрчилгүй",
      violation_list_desc:
        "Энэ хэсэгт та байгууллагаас хянасан, дижитал орчинд гарах зөрчлийн жагсаалтыг хуваалцаж, мэдээлсэн байна. Эдгээр зөрчлийг манай хиймэл оюун ухааны хэрэгсэл шинжилж, хянадаг бөгөөд энэ нь өгөгдлийг боловсруулах, хэв шинжүүдийг илрүүлэх, тохиолдлуудыг ангилах, мөн цаашид хянах, үйл ажиллагаа хэрэгжүүлэхэд шаардлагатай ойлголтуудыг бий болгоно.",
      international_btn: "Олон улсын хууль",
      mongolia_btn: "Монгол Улсын хууль",
      heading1: "Сүүн бүтээгдэхүүний орлуулагчийн зар",
      heading2: "сурталчилгааны олон улсын код болон холбогдох",
      heading3: "ДЭМБ-ын тогтоолуудын зөрчлийг мэдээлэх",
      name: "Нэр",
      email: "Цахим шуудан",
      affiliations: "Хамаарал",
      city: "Хот",
      desc: "Зөрчлийн товч тодорхойлолт",
      location: "Зөрчил хаана болсон бэ?",
      brand_name: "Брэндийн нэр",
      company_name: "Байгууллагын нэр",
      product_desc: "Тодорхойлох",
      type_violations: "Зорилготой төрөл",
      violation_desc: "Тодорхойлох",
      content: "Агуулга",
      checklist_title:
        "Нэмэлт хоол хүнс / Нярай хүүхэд, хүүхдүүдийн хоолонд зориулсан бүтээгдэхүүний хувьд шалгах зүйлс:",
      item1:
        "Бүтээгдэхүүн 6 сараас доош насны хүүхдэд тохиромжтой гэж зарласан эсэх",
      item2:
        "Бүтээгдэхүүн 6 сараас өмнө нэмэлт хооллолтыг танилцуулахгүй байх болон 2 жил хүртэл тасралтгүй хөхүүлэхийн ач холбогдлыг тэмдэглэсэн эсэх",
      item3: "Хөхүүлээр хооллохыг доромжлох текст эсвэл зураг байж байгаа эсэх",
      item4:
        "Насны заалттай байх эсэхийг үл харгалзан, эрүүл мэндийн байгууллагуудад бүтээгдэхүүн сурталчилж байгаа эсэх",
      item5:
        "Эмчилгээ, сав баглаа боодлын төрх нь сүүний орлуулагч бүтээгдэхүүнүүдтэй адилхан харагдаж байгаа эсэх (цагийн хуваарилалт)",
      violation_note:
        "(Дээрх аливаа зүйл нь 2016 оны ДЭМБ-ын зааврыг зөрчсөнд тооцогддог.)",
      attach_photo: "Хэрвээ боломжтой бол зураг хавсаргана уу",
      browser_file: "Файлуудыг хайх",
      drop_file: "Энд файлуудаа чирж, орхино уу",
      infant_formula:
        "Нялхсын сүүн тэжээл (эмчилгээний тусгай сүүн тэжээл) эсвэл (шатлал 1)",
      follow_up_formula: "Нялхсын сүүн тэжээл (шатлал 2)",

      "Infant formula (including special formula) (or Stage 1)":
        "Нялхсын сүүн тэжээл (эмчилгээний тусгай сүүн тэжээл) эсвэл (шатлал 1)",
      "Follow-up formula (or Stage 2)": "Нялхсын сүүн тэжээл (шатлал 2)",
      growing_up_milk: "Бага насны хүүхдийн сүүн тэжээл (шатлал 3)",
      "Growing-up milk (or Stage 3)": "Бага насны хүүхдийн сүүн тэжээл (шатлал 3)",
      "feeding_bottle_teat": "Сүүний сав, угж",
      complementary_foods_beverages:
        "Нярай болон бага насны хүүхдэд зориулсан нэмэлт тэжээл/ундаа",
      "Complementary milk formula for pregnant and lactating women":
        "Жирэмсэн болон хөхүүл эмэгтэйчүүдийн худалдааны сүүний тэжээл",


      "Feeding bottle and teat": "Сүүний сав, угж",
      "Complementary food or beverage / food for infants and young children (E.g. cereals, fruit/vegetables/meat puree, juice, tea, and mineral water specifically marketed for children under 36 months)":
        "Нярай болон бага насны хүүхдэд зориулсан нэмэлт тэжээл/ундаа",
      //
      "Advertisement: mass media, print, digital platforms/social media, billboards, or other channels":
        "Зар сурталчилгаа: олон нийтийн мэдээллийн хэрэгсэл, хэвлэмэл болон цахим мэдээллийн хэрэгсэл, сурталчилгааны самбар болон бусад сувгаар",
      "Company contact with pregnant women and mothers":
        "Байгууллагын бие давхар болон хүүхэдтэй эмэгтэйчүүдээр дамжуулан",
      "Free samples": "Үнэгүй дээж",
      "Donation of BMS or complementary food products to health facilities or in Emergencies":
        "Эрүүл мэндийн байгууллага, яаралтай тусламжийн төвд хандивласан нялхсын сүүн тэжээлийн бүтээгдэхүүн эсвэл нэмэлт тэжээлүүд",
      "Gift to mothers": "Ээжүүдэд бэлэг болгож өгсөн",
      "Inadequate labeling": "Дутуу шошгололт",
      "Promotion in shops": "Дэлгүүрийн сурталчилгаа",
      Sponsorship: "Спонсорлолт",
      "Other (specify)": "Бусад",
      phone_number: "Утасны дугаар",
      authority: "Зөвшөөрөл",
      edit: "Засварлах",
      delete: "Устгах",
      add_account: "Хэрэглэгч нэмэх",
      log_out: "Гарах",
      information_personal: "Хувийн мэдээлэл",
      description: "Тайлбар / тодруулга (Заавал биш)",
      place_observation: "Илрүүлсэн зөрчлийн байршил",
      submit_content:
        "Нялх, балчир хүүхдийн хүнсний зар сурталчилгааны хууль тогтоомж зөрчсөн талаар мэдүүлнэ үү.",
      contact_us: "Холбоо барих",
      contact: "Холбоо барих",
      apply: "Илгээх",
      international_code: "Олон улсын хууль",
      report_title: "Болзошгүй зөрчлийг мэдүүлэх",
      report_title1: "Болзошгүй зөрчлийг мэдүүлэх",
      detected: "Олдсон",
      no_detected: "Олдсонгүй",
      select: "Сонгох",
      cancel: "Цуцлах",
      save_changes: "Хадгалах",
      back: "Буцах",
      filter: "Шүүх",
      copied: "Хуулсан",
      not_copy: "Холболт ажиллахгүй",
      type_of_violation: "Зөрчлийн төрөл",
      detail: "Дэлгэрэнгүй",
      copy_link: "Холболтыг хуулбарлах",
      confirm_changes: "Өөрчлөлтүүдийг баталгаажуулах",
      export: "Экспорт хийх",
      rememberPass: "Нууц үгээ санаарай",
      forgetPass: "Нууц үгээ март",
      achieved: "архивласан",
      password: "Нууц үг",
      report_dsc:
        "Энэ хэсэгт та эрүүл мэндийн байгууллага, шинжлэх ухаан-мэргэжлийн арга хэмжээ, худалдааны цэгүүд, уламжлалт хэвлэл мэдээллийн хэрэгсэл, олон нийтийн газар зэрэг орчинд ажиглагдсан зөрчлийг хуваалцаж, мэдээлэх боломжтой.",
      days: ["Даваа", "Мягмар", "Лхагва", "Пүрэв", "Бямба", "Ням", "Бямба"],
      months: [
        "Нэгдүгээр",
        "Хоёрдугаар",
        "Гуравдугаар",
        "Дөрөвдүгээр",
        "Тавдугаар",
        "Зургаадугаар",
        "Тамдугаар",
        "Наймдугаар",
        "Есдүгээр",
        "Аравдугаар",
        "Арван нэгдүгээр",
        "Арван хоёрдугаар",
      ],
    },

    infant_formula:
      "Нялхсын сүүн тэжээл (эмчилгээний тусгай сүүн тэжээл эсвэл Үе шат 1)",
    follow_up_formula: "Сүүн тэжээл (Үе шат 2)",
    growing_up_milk: "Сүүн тэжээл (Үе шат 2)",
    feeding_bottle_teat: "Угж, хөхөлт",
    complementary_foods_beverages:
      "Нэмэгдэл хоол, ундаа эсвэл нялх, бага насны хүүхдэд зориулсан хоол, хүнс (жишээ нь: өглөөний хоол, жимс, ногоо, махны нухаш, шүүс, цай, эрдэст ус)",
    password: "Password",

    confirmPass: "Нууц үгийг баталгаажуулна уу",
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'mn',

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
